/**
 * Mirrors generate_product_slug() PL/pgSQL (migration 2026-06-01_01).
 * Does NOT enforce uniqueness — that is responsibility of the DB trigger.
 * Use in admin forms for slug preview, or in tests for logic verification.
 */
export function buildSlug(name) {
  if (name == null || String(name).trim() === '') return 'producto';

  let s = String(name).trim().toLowerCase();
  // Remove diacritics (mirrors unaccent())
  s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
  // Spaces and underscores → hyphen
  s = s.replace(/[\s_]+/g, '-');
  // Remove everything that is not a lowercase letter, digit, or hyphen
  s = s.replace(/[^a-z0-9-]/g, '');
  // Collapse multiple hyphens
  s = s.replace(/-{2,}/g, '-');
  // Trim leading/trailing hyphens
  s = s.replace(/^-+|-+$/g, '');
  // Fallback for empty or purely-numeric result
  // (purely-numeric slugs collide with /product/<id> legacy URLs)
  if (s === '' || /^\d+$/.test(s)) return 'producto';

  return s;
}
